define( 'b', {
	load : function( name, req, onload, config ) {
		'use strict';

		var moduleName = name,
			splitName = name.split( '/' ),
			urlReg = /^((\/\/)|(http)s?(:\/\/))+/i;

		// Do not process if the name passed in is blank
		if ( name !== '' ) {
			if ( config.paths && !Object.prototype.hasOwnProperty.call( config, name ) ) {
				if ( name.indexOf( '/' ) !== -1 && config.paths[ splitName[ 0 ] ] ) {
					config.paths[ name ] = name.replace( splitName[ 0 ], config.paths[ splitName[ 0 ] ] );
				} else if ( urlReg.test( moduleName ) ) {
					config.paths[ moduleName ] = moduleName;
				} else {
					moduleName = config.baseBlocksUrl + '/' + name;
					config.paths[ moduleName ] = moduleName;
				}
			}

			req( [ moduleName ], function loadModule( value ) {
				onload( value );
			});
		}
	},
});
